module.exports = __webpack_public_path__ + "img/william-mckinley.1cf62c38.png";